import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const BUILDING_GROUP_FORM_FIELD_NAME_TITLE = 'name'

export const BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS = 'responsible_users'

export const BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS =
  'perform_for_buildings'

export const BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS = 'buildings'

export const BUILDING_GROUP_FORM_INITIAL_VALUES = {
  [BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS]: EMPTY_LIST,
  [BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS]: EMPTY_LIST,
  [BUILDING_GROUP_FORM_FIELD_NAME_TITLE]: FORMIK_EMPTY_VALUE,
  [BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS]: false,
}

export const BUILDING_GROUP_FORM_FIELD_TITLE_MAX_LENGTH = 256

export const BUILDING_GROUP_FORM_FIELD_MANAGERS_MAX_LENGTH = 140

export const NOTIFICATION_MAX_RESPONSIBLE_MANAGERS = 'managersLimit'
